<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90%', maxWidth: '800px' }"
  [closable]="!isLoading"
  (onHide)="onHide()"
  styleClass="custom-contact-modal"
>
  <ng-template pTemplate="header">
    <div class="flex items-center gap-3">
      <lucide-icon name="flask-conical" [size]="32" class="text-primary-600">
      </lucide-icon>
      <div>
        @if (this.packLimitationsService.isDiscovery()) {
          <h2 class="mb-1 text-heading-3 font-semibold text-greyscale-950">
            {{ "discovery.contact.title" | transloco }}
          </h2>
        } @else {
          <h2 class="mb-1 text-heading-3 font-semibold text-greyscale-950">
            {{ "discovery.contact.upgradePackTitle" | transloco }}
          </h2>
        }
        <p class="text-paragraph-s-reg font-normal text-greyscale-600">
          {{ "discovery.contact.subtitle" | transloco }}
        </p>
      </div>
    </div>
  </ng-template>

  <div class="space-y-6">
    <!-- État de succès -->
    @if (showSuccess) {
      <div
        class="rounded-lg border border-validation-200 bg-validation-50 p-6 text-center"
      >
        <i class="pi pi-check-circle mb-4 text-4xl text-validation-600"></i>
        <h3 class="mb-2 text-paragraph-med font-semibold text-validation-800">
          {{ "discovery.contact.form.successMessage" | transloco }}
        </h3>
        <p class="text-paragraph-s-reg text-validation-700">
          {{ "discovery.contact.form.successAutoClose" | transloco }}
        </p>
      </div>
      <!-- Message limite atteinte -->
    } @else {
      <div class="rounded-lg border-l-4 border-primary-300 bg-primary-50 p-4">
        <h3 class="mb-2 text-paragraph-med font-semibold text-primary-800">
          @if (this.packLimitationsService.isDiscovery()) {
            {{
              "discovery.contact.limitReached"
                | transloco
                  : { limit: packLimitationsService.currentNumberOfTrips() }
            }}
          } @else if (contactModalService.content() === tripFeature) {
            {{
              packLimitationsService.canCreateTrip()
                ? ("discovery.contact.tripLimitNotReached"
                  | transloco
                    : {
                        limit: packLimitationsService.remainingTrips(),
                      })
                : ("discovery.contact.tripLimitReached" | transloco)
            }}
          } @else if (contactModalService.content() === createUser) {
            {{
              packLimitationsService.canCreateUser()
                ? ("discovery.contact.userLimitNotReached"
                  | transloco
                    : {
                        limit: packLimitationsService.remainingUsers(),
                      })
                : ("discovery.contact.userLimitReached" | transloco)
            }}
          } @else {
            {{
              "discovery.contact.featureText." + (content() ?? "generic")
                | transloco
            }}
          }
        </h3>

        <p class="text-paragraph-s-reg text-primary-700">
          {{
            "discovery.contact.description." +
              (contactModalService.content() === tripFeature
                ? "trips"
                : contactModalService.content() === createUser
                  ? "users"
                  : "generic") | transloco
          }}
        </p>
      </div>

      <!-- Formulaire de contact -->
      <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="space-y-4">
        <!-- Téléphone -->
        <div>
          <label
            for="phone"
            class="mb-2 block text-paragraph-s-med font-medium text-greyscale-700"
          >
            {{ "discovery.contact.form.phone" | transloco }}
          </label>
          <input
            pInputText
            id="phone"
            formControlName="phone"
            type="tel"
            class="w-full"
            placeholder="+32 123 45 67 89"
          />
        </div>

        <!-- Message -->
        <div>
          <label
            for="message"
            class="mb-2 block text-paragraph-s-med font-medium text-greyscale-700"
          >
            {{ "discovery.contact.form.message" | transloco }}
          </label>
          <textarea
            pTextarea
            id="message"
            formControlName="message"
            rows="4"
            class="w-full"
            [placeholder]="
              'discovery.contact.form.messagePlaceholder' | transloco
            "
          >
          </textarea>
        </div>

        <!-- Message d'erreur -->
        @if (errorMessage) {
          <div class="rounded-lg border border-error-200 bg-error-50 p-3">
            <div class="flex items-center gap-2">
              <i class="pi pi-exclamation-triangle text-error-600"></i>
              <span class="text-paragraph-s-reg text-error-800">{{
                errorMessage
              }}</span>
            </div>
          </div>
        }

        <!-- Boutons -->
        <div class="flex flex-col gap-3 pt-4 sm:flex-row sm:justify-end">
          <p-button
            type="submit"
            [label]="'discovery.contact.form.submitButton' | transloco"
            icon="pi pi-send"
            [loading]="isLoading"
            [disabled]="isLoading"
            class="order-1 flex-1 sm:order-2 sm:flex-none"
            styleClass="bg-primary-600 border-primary-600 text-white hover:bg-primary-700 hover:border-primary-700 active:bg-primary-800 active:border-primary-800 focus:ring-2 focus:ring-primary-300 focus:ring-offset-2"
          >
          </p-button>
        </div>
      </form>
    }
  </div>
</p-dialog>
